import React, {useState, useEffect} from "react";
import publicUserApi from "@api/public-user";
import {List, Typography, Row, Col} from 'antd';
import __i18n from "../../../../intl/__i18n";
import '../index.scss'
import PlatformIcon from "../../../custom/PlatformIcon";


interface Props {
  userId: string;
}


const Index = (props: Props) => {
  const {userId} = props;
  const [data, setData] = useState([]);
  
  
  useEffect(() => {
    publicUserApi.getUserAccessTokens({
        params: {
          id: userId,
        }
      })
      .then(({data}) => {
        setData(data || [])
      })
      .catch(error => {
      });
  }, [])
  
  return (
    <List
      header={<div>{__i18n("Active Sessions")}</div>}
      bordered
      dataSource={data}
      renderItem={item => (
        <List.Item>
          <Row gutter={24} className={'user-item-details'}>
            <Col span={8}>
              <PlatformIcon platform={item.device.platform}/>
    
              <label>{__i18n("Brand")}:</label>
              {" "}
              {item.device.brand || "-"}
            </Col>
            
            <Col span={8}>
              <label>{__i18n("Country")}:</label>
              {" "}
              {item.country}
            </Col>
            
            <Col span={8}>
              <label>{__i18n("IP")}:</label>
              {" "}
              {item.ip}
            </Col>
          </Row>
        </List.Item>
      )}
    />
  )
};


export default Index




